import React, { Fragment, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { attributeModifier } from '../../../utils/calculations';

import { saveCharacter } from '../../../actions/character';

const VehicleEditModal = ({
    selectedVehicle,
    character: {
        character
    },
    saveCharacter,
    closeModal
}) => {
    
    var [curVehicleData, updateCurVehicleData] = useState(selectedVehicle);

    const {
        vehiclesLevel,
        vehiclesExpertise,
        vehicles
    } = character;

    const getVehicleInventory = () => {
        if(curVehicleData.inventory !== undefined){
            
            const invElements = curVehicleData.inventory.map((item, index) => (
                <div className="compInvContainer" key={index}>
                    <div className="itemName">{item.name}</div>
                    <div className="compInvOptions">
                        <div onClick={e => removeItem(item)(e)}>Use/Drop</div>
                        <div onClick={e => giveToCharacter(item)(e)}>Give to {character.name}</div>
                    </div>
                </div>
            ));
    
            return invElements;
        }
        
    }

    const getVehicleActions = () => {

        var vehActions = []

        // Add actions from perks
        vehActions.push("Repair - Heal 4 HP of your vehicle per spare part used.")

        if(vehiclesLevel >= 0 ){
            vehActions.push("Swerve - Reroll a vehicle check with a -2 penalty.")
        }

        if(vehiclesLevel >= 5 ){
            vehActions.push("Grease Monkey - Outside combat, if vehicle's HP > " + curVehicleData.baseHP/2 + " you may heal for 2d6 HP with no spare parts.")
        }

        if(vehiclesLevel >= 15 ){
            vehActions.push("Ramming Speed - Attempt to damage enemy or obstacle by using all movement this turn (see perk info)")
        }

        if(vehiclesLevel >= 20 ){
            vehActions.push("Evasive Maneuver - Roll against single enemy DEX, on success they are at disadvantage to hit you for 3 turns.")
        }

        if(vehiclesLevel >= 40 && vehiclesExpertise === "Driver" ){
            vehActions.push("Hijack - Roll an Athletics check to try jump onto and hijack an enemy vehicle (see perk info).")
        }

        // Add actions from mods

        const actElements = vehActions.map((a, index) => (
            <div className="compInvContainer" key={index}>
                <div className="itemName">{a}</div>
            </div>
        ));

        return actElements;
        
    }

    const getVehicleCurCapacity = () => {

        var newCap = 0;

        if(selectedVehicle.inventory !== undefined){
            
            selectedVehicle.inventory.map((item) => {
                newCap += parseInt(item.weight.$numberDecimal)
            })

            
        }

        return newCap;
        
    }

    const getCurrentVehicleWeapons = () => {
        if(curVehicleData.weapons !== undefined){
            
            const eqElements = curVehicleData.weapons.map((i, index) => (
                <div className="vehWeapContainer" key={index}>
                    <div className="itemName">{i.name}</div>
                    <div>Dam: {i.numDice}d{i.diceSize}</div>
                    <div>Mag: {i.currentAmmo}/{i.magSize}</div>
                    <div className="compInvOptions">
                        <div onClick={e => removeWeapon(i)(e)} className="weapRemove">Remove</div>
                    </div>
                </div>
            ));
    
            return eqElements;
        }
        
    }

    const onChange = e => {

        var newInput = e.target.value;

        if(
            e.target.name === 'currentHP'
        ){
            newInput > selectedVehicle.baseHP && (newInput = selectedVehicle.baseHP);
        }

        if(
            e.target.name === 'currentDIS'
        ){
            newInput > selectedVehicle.baseDIS && (newInput = selectedVehicle.baseDIS);
        }

        if(
            e.target.name === 'currentKIN'
        ){
            newInput > selectedVehicle.baseKIN && (newInput = selectedVehicle.baseKIN);
        }

        updateCurVehicleData({
            ...curVehicleData,
            [e.target.name]: newInput
        });
    }

    const saveVehicle = () => e => {
        const updatedVehicles = [...vehicles];
        const curInd = vehicles.findIndex(x => x._id === curVehicleData._id);

        updatedVehicles[curInd] = curVehicleData;

        saveCharacter({
            ...character,
            "vehicles": updatedVehicles
        });

        closeModal();
    }

    const removeItem = (item) => (e) => {

        var newVehInv = [...curVehicleData.inventory]

        newVehInv.splice(newVehInv.findIndex(x => x.name === item.name),1);

        var curVehs = [...character.vehicles];

        // Save index of selected companion and current state of inventory as vars
        var vehInd = curVehs.findIndex(x => x.name === selectedVehicle.name);

        // Create a new companion object with updated inventory
        var newVeh = {
            ...selectedVehicle,
            "inventory": [...newVehInv]
        }

        updateCurVehicleData(newVeh);

        // Save the new companion data into the variable companion list
        curVehs[vehInd] = newVeh;

        // Save character
        saveCharacter({
            ...character,
            "vehicles": curVehs
        });
    }

    const removeWeapon = (w) => (e) => {

        var newVehWeaps = [...curVehicleData.weapons]

        newVehWeaps.splice(newVehWeaps.findIndex(x => x.name === w.name),1);

        var curVehs = [...character.vehicles];

        // Save index of selected companion and current state of inventory as vars
        var vehInd = curVehs.findIndex(x => x.name === selectedVehicle.name);

        // Create a new companion object with updated inventory
        var newVeh = {
            ...selectedVehicle,
            "weapons": [...newVehWeaps]
        }

        updateCurVehicleData(newVeh);

        // Save the new companion data into the variable companion list
        curVehs[vehInd] = newVeh;

        // Save character
        saveCharacter({
            ...character,
            "vehicles": curVehs
        });
    }

    const giveToCharacter = (item) => (e) => {

        // Update the comp's inventory to not include the selected item
        var newVehicleInv = [...curVehicleData.inventory]

        newVehicleInv = newVehicleInv.filter(i => i._id !== item._id);

        var curVehicles = [...character.vehicles];

        // Save index of selected companion and current state of inventory as vars
        var vehicleInd = curVehicles.findIndex(x => x._id === selectedVehicle._id);

        // Create a new companion object with updated inventory
        var newVehicle = {
            ...selectedVehicle,
            "inventory": [...newVehicleInv]
        }

        updateCurVehicleData(newVehicle);

        // Save the new companion data into the variable companion list
        curVehicles[vehicleInd] = newVehicle;

        var newCharInv = [...character.inventory, item]

        // Save character
        saveCharacter({
            ...character,
            "inventory": newCharInv,
            "vehicles": curVehicles
        });

        
    }

    return (
        <Fragment>
            <div className="vehicleContainer">
                <div className="vehicleContCol">
                    <h1 className="marx-2">{selectedVehicle.name}</h1>
                    <div>{selectedVehicle.description}</div>
                    <div className="compAttrContainer">
                        <h3 className="text-blue">Notes</h3>
                        <textarea className="info-container" name='notes' value={curVehicleData.notes} cols="20" rows="18" onChange={onChange}></textarea>
                    </div>
                </div>
                <div className="vehicleContCol">
                    <div>
                        <h3 className="text-blue">Health & Defense</h3>
                        <div className="vehicleContRow">
                            <div className="compDefContainer">
                                <p>HP</p>
                                <input type="number" name='currentHP' value={curVehicleData.currentHP} onChange={onChange} />/ <span>{selectedVehicle.baseHP}</span>
                            </div>
                            <div className="compDefContainer">
                                <p>DIS</p>
                                <input type="number" name='currentDIS' value={curVehicleData.currentDIS} onChange={onChange} />/ <span>{selectedVehicle.baseDIS}</span>
                            </div>
                            <div className="compDefContainer">
                                <p>KIN</p>
                                <input type="number" name='currentKIN' value={curVehicleData.currentKIN} onChange={onChange} />/ <span>{selectedVehicle.baseKIN}</span>
                            </div>
                        </div>
                        
                    </div>
                    <div className="compStatContainer">
                        <h3 className="text-blue">
                            Other Stats
                        </h3>
                        <div className="vehicleContRow">
                            <div>
                                <p>Movement</p>
                                <div>{selectedVehicle.movement}</div>
                            </div>
                            <div>
                                <p>Carrying Capacity</p>
                                <div className="compDefContainer">
                                    {getVehicleCurCapacity()} / <span>{selectedVehicle.maxCapacity}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="compAttrContainer">
                        <h3 className="text-blue">Actions</h3>
                        {getVehicleActions()}
                    </div>
                </div>
                <div className="vehicleContCol">
                    <div className="compAttrContainer">
                        <h3 className="text-blue">Weapons</h3>
                        {getCurrentVehicleWeapons()}
                    </div>
                    <div className="compAttrContainer">
                        <h3 className="text-blue">Mods</h3>
                        {}
                    </div>
                    <div className="compAttrContainer">
                        <h3 className="text-blue">Inventory</h3>
                        {getVehicleInventory()}
                    </div>
                </div>
            </div>
        <div/>
        <div className="saveCompButContainer">
            <div className="saveCompBut" onClick={e => saveVehicle()(e)}>Save Vehicle Info</div>
        </div>
        </Fragment>
    );
};

VehicleEditModal.propTypes = {
    selectedVehicle: PropTypes.object.isRequired,
    character: PropTypes.object.isRequired,
    saveCharacter: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    character: state.character
});

export default connect(mapStateToProps, {saveCharacter})(VehicleEditModal);